import { useRef } from "react";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";

const HandleUpdateMultiselector = (field, newValues, targetID, route, debounceUpdate, setElements = null) => {

  const filteredValues = newValues.map((v) => (typeof v === "object" ? v.id : v));
  
  if (setElements) {
    setElements((P) =>
      P.map((e) =>
        e.id === targetID
          ? {
              ...e,
              [field]: filteredValues,
            }
          : e
      )
    );
  }

  if (debounceUpdate.current) {
    clearTimeout(debounceUpdate.current);
  }

  // Configurar nuevo debounce
  debounceUpdate.current = setTimeout(async () => {
    try {
      await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
        [field]: newValues,
      });

    } catch (e) {
      console.log(e)
      toast.error("Error al actualizar el dato: " + e);
    }
  }, 1500);
};

export default HandleUpdateMultiselector